var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutEasilyaddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADW0lEQVR4nO2bTW7TQBiG32/siMRSUWtVEZFQ2YUFx2DRFYfoDYAD8HMCLkJvwAlgmX1bIVcNVZvgiqAk9sywaAcq1GTG47Enbv2uv4m/5/E4mRkrJKXEQw7z3YDvtAJ8N+A7rQDfDfhOK8B3A74T6gr29/ddXesNgLcAxKoCKSWIiG1vb3/p9XoHtmsUIgIR4erqCoeHh2trtQIcpg/gqa6IiBBF0bNutwshVrpaO56IkKYpZrOZtr5OAQvTQiHEbyFEYQFEBABI0xSXl5dGY+7Nd8Dtaa/glZB1uRcCbOGBeyCgDDzQcAFl4YEGC3ABDzRUgCt4oIECXMIDDRPgGh5okIAq4IGGCKgKHmiAgCrhgQ0XUDU8UO9mqFAUaJXwQL0zwHhzT0RgjFUOD9QrYG5SdDPtl7e3tLbwJgcqJo/AawAx1pzk6PoAwAG81BUq0Ol0+mI+n78HIInI9iaxIAimAD6tKzIR8BHAY8smCkcIgdlsNiSiD2WmPeccURT9gkaAid3UugvLMMacPPNE9FN7LYPPafLbU23vG70OqCOtAN8N+E4rwHcDvqNdB0gpjVZUuqiNjUlcXNP0xYrJQigOQ/s9k5Ty7+96nudGY4IgABGVkkBECIIg1tVpyYbD4ec4jp9wzrlNI4wxhGEojo+PnydJMgyCYGWtAt7b2zsfDAbf8jyXUkrbFVFARD90RVoBg8HgYGtrCzb8RIROp4PT01NcXFy8w/WyWjsmy7KvjLFX/X4fQggnj+CqaAXkeY4sywoLUPAnJycYjUbIskyaPEo3AmSSJFgsFojj2FqCt3eDt+/8aDTCcrlEGIar5/7/TTHGpJQYj8eYTCbO9gZ3Xsv1B94F3+l0ijfGrlurWoJTAa7gVeqQ4EyAa3iVqiU4EVAVvEqVEkoLqBpepSoJpQTUBa9ShQRrAXXDq7iWYCXAF7yKSwmFBfiGV3EloZCATYFXcSHBWMCmwauUlWAkYFPhVcpI0ArYdHgVWwna/WkYhk7ghRCPdCdC6vSIcx7ZHIsREYQQODs7gxACu7u72jFaAePxGEdHR8iyzBpeSolut3u+s7OTXO907wa7EUC9Xu878O+uFgkRgXOOyWRi1C+1/xt84GkF+G7Ad1oBvhvwnVaA7wZ85w+LhxNYZdKS8QAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-67.934 -0.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.934,14.98h14V.98h-14Z",
    fill: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutEasilyaddIcon);
export default __webpack_public_path__ + "static/media/tut-easilyadd-icon.864534c6795febecfaf36f286c3355d1.svg";
export { ForwardRef as ReactComponent };